export const SET_PROFILE = 'SET_PROFILE';
export const SET_MEDIA_LIST = 'SET_MEDIA_LIST';
export const SET_MEDIA_LIST_PAGE_INFO = 'SET_MEDIA_LIST_PAGE_INFO';
export const SET_INVITE_CODE = 'SET_INVITE_CODE';
export const SET_MK_OPEN_URL = 'SET_MK_OPEN_URL';
export const INIT_WINDOWSHOP_FROM = 'INIT_WINDOWSHOP_FROM';
export const SET_WINDOWSHOP_FROM = 'SET_WINDOWSHOP_FROM';
export const SET_IS_SHOW_WINDOWSHOP_POP = 'SET_IS_SHOW_WINDOWSHOP_POP';
// 设置结算基本信息
export const SET_SETTLEMENT_INFO = 'SET_SETTLEMENT_INFO';
export const SET_USER_MEDIA_LIST = 'SET_USER_MEDIA_LIST';
export const SET_BIND_MEDIA_INFO = 'SET_BIND_MEDIA_INFO';
